import React, { useState } from 'react';
import styles from './styles/publications_and_patents.module.scss';
import json_publications_and_patents_en from './jsons/en/publications_and_patents_en.json';
import json_publications_and_patents_pt from './jsons/pt/publications_and_patents_pt.json';

const PublicationsAndPatents = () => {

    //////////////////////////////////////////////////////////////////////////////////////
    // VARIABLES
    //////////////////////////////////////////////////////////////////////////////////////
    // json data
    const [language, set_language] = useState(localStorage.getItem("language"));
    const json_data = language === "EN"
        ? json_publications_and_patents_en
        : json_publications_and_patents_pt;

    // listen for language changes
    window.addEventListener('language', () => {
        set_language(localStorage.getItem("language"));
    });

    return (
        <div className={styles.root}>
            <div className={styles.suptitle}>
                {json_data.suptitle}
            </div>

            <div className={styles.root_background_fade} />

            <div className={styles.static_container}>
                {json_data.items.map((item, index) => (
                    <div
                        key={index}
                        className={styles.static_card}
                    >

                        <img
                            src={require(`${item[1]}`)}
                            alt="publication"
                            className={styles.static_image}
                        />

                        <div
                            className={styles.static_title}
                            dangerouslySetInnerHTML={{
                                __html: item[0]
                            }}
                        />

                        <a
                            href={require(`${item[2]}`)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.static_button}
                        >
                            {json_data.button_text}
                        </a>

                    </div>
                ))}
            </div>
        </div>
    );
}

export default PublicationsAndPatents;